import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function FAQ() {
  const { t } = useI18n();
  const location = useLocation();
  const [openValue, setOpenValue] = useState(undefined);

  // Ouvre + scroll vers l'item ciblé par l'URL hash (#item-N) — utilisé par
  // la barre de recherche du site pour envoyer directement à la réponse.
  useEffect(() => {
    const hash = (location.hash || "").replace(/^#/, "");
    if (!hash) return;
    // Attendre le rendu du contenu (traductions) puis scroller + ouvrir
    const timer = setTimeout(() => {
      setOpenValue(hash);
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 200);
    return () => clearTimeout(timer);
  }, [location.hash, t.faq.items]);

  return (
    <div data-testid="faq-page">
      <section className="relative py-24 border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="label-tech">{t.faq.title}</span>
          <h1 className="mt-3 font-display text-5xl sm:text-6xl font-bold uppercase tracking-tight">
            <span className="chrome-text">{t.faq.title}</span>
          </h1>
          <p className="mt-5 text-zinc-400 font-body max-w-2xl">{t.faq.subtitle}</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
        <Accordion
          type="single"
          collapsible
          className="space-y-3"
          data-testid="faq-accordion"
          value={openValue}
          onValueChange={setOpenValue}
        >
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              id={`item-${i}`}
              value={`item-${i}`}
              className="bg-[#080808] border border-white/5 px-5 data-[state=open]:border-[#39FF14]/40 transition-colors scroll-mt-24"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display uppercase tracking-wider text-left text-sm sm:text-base hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 font-body leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
